import { createRouter, createWebHistory } from "vue-router";

// import PowderAmountCalibrationDetail from "../views/applications/flightpath/PowderAmountCalibrationDetail.vue";
// import PowderAmountCalibrationsLibrary from "../views/applications/flightpath/PowderAmountCalibrationsLibrary.vue";
import AdvancedPowderModelAdd from "../views/applications/flightpath/AdvancedPowderModelAdd.vue";
import Bagging from "../views/applications/steelcase/Bagging.vue";
import BenchmarkAndTarget from "../views/applications/blueprint/BenchmarkAndTarget.vue";
import BluePrint from "../views/applications/blueprint/BluePrint.vue";
import Copilot from "../views/applications/copilot/Copilot.vue";
import Dashboard from "../views/dashboards/Dashboard.vue";
import DiameterMeasurement from "../views/applications/steelcase/DiameterMeasurement.vue";
import FineTune from "../views/applications/blueprint/finetune/FineTune.vue";
import FineTuneLineDashboard from "../views/applications/blueprint/finetune/FineTuneLineDashboard.vue";
import FixedLineOptimizationDetail from "../views/applications/flightpath/FixedLineOptimizationDetail.vue";
import FlightPath from "../views/applications/flightpath/FlightPath.vue";
import GenerateMonthlyUsageReport from "../views/applications/generatemonthlyusagereport/GenerateMonthlyUsageReport.vue";
import GunsEqualization from "../views/applications/blueprint/GunsEqualization.vue";
import GunsEqualizationFineTune from "../views/applications/blueprint/finetune/GunsEqualizationFineTune.vue";
import HealthCheck from "../views/applications/blueprint/HealthCheck.vue";
import LineDetail from "../views/applications/flightpath/LineDetail.vue";
import LineDetailBluePrint from "../views/applications/blueprint/LineDetailBluePrint.vue";
import LineDetailSteelCase from "../views/applications/steelcase/LineDetailSteelCase.vue";
import LineVisits from "../views/applications/blueprint/LineVisits.vue";
import NotFound from "../views/NotFound.vue";
import OptimizationDetail from "../views/applications/flightpath/OptimizationDetail.vue";
import OptimizationsLibrary from "../views/applications/flightpath/OptimizationsLibrary.vue";
import PowderModelAdd from "../views/applications/flightpath/PowderModelAdd.vue";
import PowderModelAddBluePrint from "../views/applications/blueprint/PowderModelAddBluePrint.vue";
import PowderModelDetail from "../views/applications/flightpath/PowderModelDetail.vue";
import PowderModelsLibrary from "../views/applications/flightpath/PowderModelsLibrary.vue";
import PowderSavingsCalculator from "../views/demo/powdersavingscalculator/PowderSavingsCalculator.vue";
import PublicFixedLineOptimizationDetail from "../views/applications/flightpath/PublicFixedLineOptimizationDetail.vue";
import PublicOptimizationDetail from "../views/applications/flightpath/PublicOptimizationDetail.vue";
import ReciprocatorOptimizationDetail from "../views/applications/blueprint/ReciprocatorOptimizationDetail.vue";
import ReciprocatorOptimizationsLibrary from "../views/applications/blueprint/ReciprocatorOptimizationsLibrary.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import ResetPasswordByEmail from "../views/auth/ResetPasswordByEmail.vue";
import ResetPasswordConfirmation from "../views/auth/ResetPasswordConfirmation.vue";
import SignIn from "../views/auth/SignIn.vue";
import SprayPatternStage from "../views/applications/blueprint/SprayPatternStage.vue";
import StaticPowderModelAdd from "../views/applications/flightpath/StaticPowderModelAdd.vue";
import SteelCase from "../views/applications/steelcase/SteelCase.vue";
import SteelCaseDashboard from "../views/applications/steelcase/SteelCaseDashboard.vue";
import MaintenanceSteelcase from "../views/applications/steelcase/MaintenanceSteelcase.vue";
import store from "../store";
import ThicknessAdjustment from "../views/applications/blueprint/ThicknessAdjustment.vue";
import ThicknessAdjustmentFineTune from "../views/applications/blueprint/finetune/ThicknessAdjustmentFineTune.vue";
import ThicknessAdjustmentSteelcase from "../views/applications/steelcase/ThicknessAdjustmentSteelcase.vue";
import ViewRecipes from "../views/applications/steelcase/ViewRecipes.vue";
import CreateRecipe from "../views/applications/steelcase/CreateRecipe.vue";
import ResetRecipe from "../views/applications/steelcase/ResetRecipe.vue";
import SendRecipeSettingsToPLCs from "../views/applications/steelcase/SendRecipeSettingsToPLCs.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: { name: "Dashboard" },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/applications/flightpath",
    name: "FlightPath",
    component: FlightPath,
  },
  {
    path: "/applications/copilot",
    name: "Copilot",
    component: Copilot,
  },
  {
    path: "/applications/blueprint",
    name: "BluePrint",
    component: BluePrint,
  },
  {
    path: "/finetune",
    name: "FineTune",
    component: FineTune,
  },
  {
    path: "/finetune/:lineId/",
    name: "FineTuneLineDashboard",
    component: FineTuneLineDashboard,
    props: true,
  },
  {
    path: "/finetune/gunsequalization/:lineId/:gunsEqualizationId?",
    name: "GunsEqualizationFineTune",
    component: GunsEqualizationFineTune,
    props: true,
  },
  {
    path: "/finetune/thicknessadjustment/:lineId/:thicknessAdjustmentFineTuneId?",
    name: "ThicknessAdjustmentFineTune",
    component: ThicknessAdjustmentFineTune,
    props: true,
  },
  {
    path: "/auth/sign-in",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/auth/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/auth/reset-password-by-email",
    name: "ResetPasswordByEmail",
    component: ResetPasswordByEmail,
  },
  {
    path: "/reset-password/confirm/:uid/:token/",
    name: "ResetPasswordConfirmation",
    component: ResetPasswordConfirmation,
    props: true,
  },
  {
    path: "/applications/flightpath/optimization/:lineId/:optimizationTypeProp?/:flightpathIdProp?",
    name: "OptimizationDetail",
    component: OptimizationDetail,
    props: true,
  },
  {
    path: "/applications/flightpath/optimization/public/:lineId/:optimizationTypeProp?/:flightpathIdProp?",
    name: "PublicOptimizationDetail",
    component: PublicOptimizationDetail,
    props: true,
  },
  {
    path: "/applications/flightpath/fixedlineoptimization/public/:lineId/:optimizationTypeProp?/:flightpathIdProp?",
    name: "PublicFixedLineOptimizationDetail",
    component: PublicFixedLineOptimizationDetail,
    props: true,
  },
  {
    path: "/applications/blueprint/optimization/:lineId/:visitId/:optimizationTypeProp?/:flightpathIdProp?",
    name: "ReciprocatorOptimizationDetail",
    component: ReciprocatorOptimizationDetail,
    props: true,
  },
  {
    path: "/applications/flightpath/optimizationslibrary/:lineId",
    name: "OptimizationsLibrary",
    component: OptimizationsLibrary,
    props: true,
  },
  {
    path: "/applications/flightpath/powdermodelslibrary/:lineId",
    name: "PowderModelsLibrary",
    component: PowderModelsLibrary,
    props: true,
  },
  {
    path: "/applications/flightpath/powdermodelslibrary/:powdermodelType/:powdermodelId",
    name: "PowderModelDetail",
    component: PowderModelDetail,
    props: true,
  },
  {
    path: "/applications/blueprint/powdermodel/:powdermodelType/:powdermodelId",
    name: "PowderModelDetailBluePrint",
    component: PowderModelDetail,
    props: true,
  },
  {
    path: "/applications/flightpath/powdermodelslibrary/advancedpowdermodeladd/:lineId",
    name: "AdvancedPowderModelAdd",
    component: AdvancedPowderModelAdd,
    props: true,
  },
  {
    path: "/applications/flightpath/powdermodelslibrary/powdermodeladd/:lineId",
    name: "PowderModelAdd",
    component: PowderModelAdd,
    props: true,
  },
  {
    path: "/applications/flightpath/powdermodelslibrary/staticpowdermodeladd/:lineId",
    name: "StaticPowderModelAdd",
    component: StaticPowderModelAdd,
    props: true,
  },
  {
    path: "/applications/line/:lineIdProp?",
    name: "LineDetail",
    component: LineDetail,
    props: true,
  },
  {
    path: "/applications/flightpath/fixedlineoptimization/:lineId/:optimizationTypeProp?/:flightpathIdProp?",
    name: "FixedLineOptimizationDetail",
    component: FixedLineOptimizationDetail,
    props: true,
  },
  {
    path: "/applications/generatemonthlyusagereport/",
    name: "GenerateMonthlyUsageReport",
    component: GenerateMonthlyUsageReport,
  },
  // {
  //   path: '/applications/flightpath/powderamountcalibrationslibrary/:lineId',
  //   name: 'PowderAmountCalibrationsLibrary',
  //   component: PowderAmountCalibrationsLibrary,
  //   props: true,
  // },
  // {
  //   path: '/applications/flightpath/powderamountcalibrationslibrary/powderamountcalibration/:lineId/:powderAmountCalibrationIdProp?',
  //   name: 'PowderAmountCalibrationDetail',
  //   component: PowderAmountCalibrationDetail,
  //   props: true,
  // },
  {
    path: "/applications/blueprint/linedetail/:lineId",
    name: "LineDetailBluePrint",
    component: LineDetailBluePrint,
    props: true,
  },
  {
    path: "/applications/blueprint/linevisits/:lineId",
    name: "LineVisits",
    component: LineVisits,
    props: true,
  },
  {
    path: "/applications/blueprint/benchmarkandtarget/:lineId/:visitId",
    name: "BenchmarkAndTarget",
    component: BenchmarkAndTarget,
    props: true,
  },
  {
    path: "/applications/blueprint/healthcheck/:lineId/:visitId",
    name: "HealthCheck",
    component: HealthCheck,
    props: true,
  },
  {
    path: "/applications/blueprint/gunsequalization/:lineId/:visitId",
    name: "GunsEqualization",
    component: GunsEqualization,
    props: true,
  },
  {
    path: "/applications/blueprint/reciprocatoroptimizationslibrary/:lineId/:visitId",
    name: "ReciprocatorOptimizationsLibrary",
    component: ReciprocatorOptimizationsLibrary,
    props: true,
  },
  {
    path: "/applications/blueprint/thicknessadjustment/:lineId/:visitId/",
    name: "ThicknessAdjustment",
    component: ThicknessAdjustment,
    props: true,
  },
  {
    path: "/applications/blueprint/powdermodels/:lineId/:visitId",
    name: "SprayPatternStage",
    component: SprayPatternStage,
    props: true,
  },
  {
    path: "/applications/blueprint/powdermodeladd/:lineId/:visitId/:powderId",
    name: "PowderModelAddBluePrint",
    component: PowderModelAddBluePrint,
    props: true,
  },
  {
    path: "/powdersavingscalculator/:calculatorTypeProp?",
    name: "PowderSavingsCalculator",
    component: PowderSavingsCalculator,
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/steelcase",
    name: "SteelCase",
    component: SteelCase,
  },
  {
    path: "/steelcase/:lineId",
    name: "SteelCaseDashboard",
    component: SteelCaseDashboard,
    props: true,
  },
  {
    path: "/applications/steelcase/linedetail/:lineId",
    name: "LineDetailSteelCase",
    component: LineDetailSteelCase,
    props: true,
  },
  {
    path: "/steelcase/diametermeasurement/:lineId/:diameterMeasurementId?",
    name: "DiameterMeasurement",
    component: DiameterMeasurement,
    props: route => ({
      lineId: route.params.lineId,
      diameterMeasurementId: route.params.diameterMeasurementId,
    }),
  },
  {
    path: "/steelcase/bagging/:lineId/:powderOutputMeasurementId?",
    name: "Bagging",
    component: Bagging,
    props: true,
  },
  {
    path: "/steelcase/viewrecipes/:lineId",
    name: "ViewRecipes",
    component: ViewRecipes,
    props: true,
  },
  {
    path: "/steelcase/createrecipe/:lineId",
    name: "CreateRecipe",
    component: CreateRecipe,
    props: true,
  },
  {
    path: "/steelcase/resetrecipe/:lineId/hopper/:hopperId/recipe/:recipeId",
    name: "ResetRecipe",
    component: ResetRecipe,
    props: true,
  },
  {
    path: "/steelcase/thicknessadjustment/:lineId/",
    name: "ThicknessAdjustmentSteelcase",
    component: ThicknessAdjustmentSteelcase,
    props: true,
  },
  {
    path: "/steelcase/maintenance/:lineId/",
    name: "MaintenanceSteelcase",
    component: MaintenanceSteelcase,
    props: true,
  },
  {
    path: "/steelcase/sendrecipessettingstoplcs/",
    name: "SendRecipeSettingsToPLCs",
    component: SendRecipeSettingsToPLCs,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async to => {
  store.commit("setLoading", true);

  if (
    !store.state.user_data_loaded &&
    to.name !== "SignIn" &&
    to.name !== "ResetPasswordByEmail" &&
    to.name !== "ResetPasswordConfirmation" &&
    to.name !== "PublicOptimizationDetail" &&
    to.name !== "PublicFixedLineOptimizationDetail"
  ) {
    await store.dispatch("getUserData");
  }

  if (
    // redirect to PowderSavingsCalculator without EXPO license
    (to.path == "/powdersavingscalculator/expo" || to.path == "/powdersavingscalculator/expo/") &&
    (!store.state.isAuthenticated || !store.state.user_data.powder_savings_calculator_license)
  ) {
    store.commit("setLoading", false);
    return { name: "/powdersavingscalculator" };
  }

  if (
    // redirect to PowderSavingsCalculator EXPO version if user has expo license
    store.state.isAuthenticated &&
    to.path == "/powdersavingscalculator/" &&
    store.state.user_data.powder_savings_calculator_license
  ) {
    store.commit("setLoading", false);
    return { path: "/powdersavingscalculator/expo" };
  }

  if (
    store.state.isAuthenticated &&
    to.path.startsWith("/finetune/powderequalization") &&
    store.state.finetune_license == false
  ) {
    return { path: "/" };
  }
  if (to.path.includes("/public/") && !store.state.isAuthenticated) {
    store.commit("setLoading", false);
    store.commit("setPublicInfo", true);
  }

  if (
    // if user is not authenticated and is not navigating to SignIn page, redirect to SignIn page
    !store.state.isAuthenticated &&
    to.name !== "SignIn" &&
    to.name !== "PowderSavingsCalculator" &&
    to.name !== "ResetPasswordByEmail" &&
    to.name !== "ResetPasswordConfirmation" &&
    to.name !== "PublicOptimizationDetail" &&
    to.name !== "PublicFixedLineOptimizationDetail"
  ) {
    // redirect the user to the SignIn page
    store.commit("setLoading", false);
    return { name: "SignIn" };
  }

  if (
    // if user is authenticated and is navigating to SignIn page, redirect to root url
    store.state.isAuthenticated &&
    to.name == "SignIn"
  ) {
    // redirect the user to the root path
    return { path: "/" };
  }

  if (
    // if user is authenticated and has not changed password, redirect to ResetPassword page
    store.state.isAuthenticated &&
    !store.state.user_data.changed_password &&
    to.name !== "ResetPassword"
  ) {
    return { name: "ResetPassword" };
  }

  if (
    // if user is authenticated and has multiple active licenses, redirect to Dashboard
    store.state.total_active_licenses > 1 &&
    to.name == "Dashboard"
  ) {
    store.commit("setLoading", false);
  }

  if (
    store.state.total_active_licenses == 1 &&
    (store.state.flightpath_pro_license || store.state.flightpath_standard_license) &&
    to.name == "Dashboard"
  ) {
    return { name: "FlightPath" };
  }

  if (store.state.total_active_licenses == 1 && store.state.blueprint_license == true && to.name == "Dashboard") {
    return { name: "BluePrint" };
  }

  if (store.state.total_active_licenses == 1 && store.state.finetune_license == true && to.name == "Dashboard") {
    return { name: "FineTune" };
  }

  if (store.state.total_active_licenses == 1 && store.state.steelcase_license == true && to.name == "Dashboard") {
    return { name: "SteelCase" };
  }

  if (
    // if natigating to any route that starts with applications/flightpath and user has no flightpath license
    to.path.startsWith("/applications/flightpath") &&
    !to.path.includes("/public/") &&
    !store.state.flightpath_pro_license &&
    !store.state.flightpath_standard_license
  ) {
    return { name: "Dashboard" };
  }

  if (
    // if natigating to any route that starts with /applications/blueprint and user has no blueprint license
    to.path.startsWith("/applications/blueprint") &&
    !to.path.includes("/public/") &&
    !store.state.blueprint_license
  ) {
    return { name: "Dashboard" };
  }

  store.commit("setLoading", false);
});

export default router;
